import React from 'react';
interface ReadyToggleProps {
  ready: boolean;
  disabled: boolean;
  label: string;
  onToggle: () => void;
}
export function ReadyToggle({
  ready,
  disabled,
  label,
  onToggle
}: ReadyToggleProps) {
  return <input type="checkbox" checked={ready} disabled={disabled} onChange={onToggle} aria-label={label} className={`h-4 w-4 rounded border-slate-300 text-rcm-500 focus:ring-rcm-500 ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}`} data-id="element-109" data-mp="jnv0s5vasjk1" />;
}